import { environment } from 'src/environments/environment';

export class AppConstants {
    public static UseMock = false;

    public static SofiaURL = {
        MyFederale: environment.myFederale,
        WWWFederale: environment.wwwFederale
    };

    public static Languages = {        
        AllLanguages: ['FR', 'NL'],
        DefaultLanguage: 'NL'
    };

    public static APIURLS = {
    }
}